module.exports = __webpack_public_path__ + "img/zdcn.928057c9.png";